import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const AsymptoticNotationsGrowthOrders = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Types of Asymptotic Notations and Orders of Growth"
    videos={[
      "https://www.youtube.com/embed/7dz8Iaf_weM",
      "https://www.youtube.com/embed/cFZ_0jXaaAQ"
    ]}
    takeaways={[
      { text: "Mostly theoretical questions are asked from this topic." },
      { text: "Indirect, concept-based questions can also be expected." }
    ]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default AsymptoticNotationsGrowthOrders;
